import { useMutation } from "@apollo/client";

import { ManagedUserGroupUpdateInputV2 } from "types/generated";

import { UPDATE_MANAGED_USER_GROUP_V2 } from "./gql";

const useUpdateGroup = () => {
  const [updateManagedUserGroup, { loading }] = useMutation(UPDATE_MANAGED_USER_GROUP_V2, {
    refetchQueries: ["GetManagedUserGroupsV2"],
  });

  const onUpdate = (input: ManagedUserGroupUpdateInputV2) => {
    return updateManagedUserGroup({
      variables: {
        input,
      },
    });
  };

  return { onUpdate, loading };
};

export default useUpdateGroup;
